import { ConfirmDeleteButton } from '@ui/modals';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { useAction } from '@hooks';
import React, { useCallback } from 'react';
export const DeleteInitiativeScopeButton = ({ initiativeId, sonarObjectIds, selectedObjectType, onDelete }) => {
    const deleteBulkInitiativeScope = useAction(coreActions.requestDeleteCoreInitiativesSonarObjects);
    const handleBulkDeleteScope = useCallback(() => {
        deleteBulkInitiativeScope({
            initiativeId: initiativeId,
            sonarObjectIds: sonarObjectIds
        });
        onDelete();
    }, [deleteBulkInitiativeScope, initiativeId, sonarObjectIds, onDelete]);
    const title = COPY_SPECIFIC.ARE_YOU_SURE_DELETE_SCOPE(sonarObjectIds.length, selectedObjectType !== null && selectedObjectType !== void 0 ? selectedObjectType : 'scope items');
    return (React.createElement(ConfirmDeleteButton, { buttonId: 'initiative-scope-table-delete-button', buttonLabel: COPY_SPECIFIC.REMOVE, cancelButtonProps: {
            id: 'initiative-scope-table-cancel-button'
        }, confirmButtonProps: {
            id: 'initiative-scope-table-confirm-button',
            value: COPY_SPECIFIC.REMOVE
        }, onConfirm: handleBulkDeleteScope, placement: 'bottomRight', title: title, type: 'text' }));
};
